import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nbia-feedback-and-legacy-buttons',
  templateUrl: './feedback-and-legacy-buttons.component.html',
  styleUrls: ['./feedback-and-legacy-buttons.component.scss']
})
export class FeedbackAndLegacyButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
